import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    sourceComponent: '',
    isPreviewOpen: false,
}

const modalPreviewSelectedPhotoSlice = createSlice({
    name: 'modalPreviewSelectedPhotoSlice',
    initialState,
    reducers: {
        openPreview: (state, action) => {
            const source = action.payload;
            state.sourceComponent = source;
            state.isPreviewOpen = true;
        },
        closePreview: (state) => {
            state.isPreviewOpen = false;
        },
    }
});

const {actions, reducer: modalPreviewSelectedPhotoReducer} = modalPreviewSelectedPhotoSlice;

const modalPreviewSelectedPhotoActions = {
    ...actions,
}

export {
    modalPreviewSelectedPhotoActions,
    modalPreviewSelectedPhotoReducer,
}